"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _InputError = _interopRequireDefault(require("./InputError"));

var _InputLabel = _interopRequireDefault(require("./InputLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _lodash = _interopRequireDefault(require("lodash"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Select = _styledComponents["default"].select.withConfig({
  displayName: "SelectInput__Select",
  componentId: "vcdg19-0"
})(["width:100%;padding:16px;margin-bottom:8px;border-radius:3px;border:1px solid rgba(0,0,0,0.25);font-size:16px;-webkit-appearance:none;box-sizing:border-box;box-shadow:none;&:disabled{backgroundcolor:#e6e6e6;}:focus{outline:none !important;}&:focus{box-shadow:0 0 2px 2px #6192ff;}", ";"], function (props) {
  if (props.inputStyle === "dark") {
    return (0, _styledComponents.css)(["color:#0c4e69;background-color:#062633;&:disabled{background-color:#031117;}"]);
  } else if (props.inputStyle === "darker") {
    return (0, _styledComponents.css)(["color:#0c4e69;background-color:#061e26;&:disabled{background-color:#000000;}"]);
  } else if (props.inputStyle === "light") {
    return (0, _styledComponents.css)(["color:#111;background-color:#fff;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "muted") {
    return (0, _styledComponents.css)(["color:#666666;background-color:#f7f7f7;border:1px solid #e0e0e0;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "achievement") {
    return (0, _styledComponents.css)(["fontSize:16px background-color:#FCFCFC;border:1px solid #E6E6E6;color:#000;padding:20px;&:disabled{background-color:#e6e6e6;}"]);
  }
});

var SelectInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SelectInput, _Component);

  var _super = _createSuper(SelectInput);

  function SelectInput() {
    (0, _classCallCheck2["default"])(this, SelectInput);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          required = _this$props.required,
          label = _this$props.label,
          labelStyle = _this$props.labelStyle,
          initialValue = _this$props.initialValue,
          style = _this$props.style,
          name = _this$props.name,
          options = _this$props.options,
          error = _this$props.error,
          disableInitial = _this$props.disableInitial,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["required", "label", "labelStyle", "initialValue", "style", "name", "options", "error", "disableInitial"]); // value must be undefined

      var SelectPlaceholder = /*#__PURE__*/_react["default"].createElement("option", {
        value: disableInitial ? "" : undefined,
        disabled: disableInitial
      }, initialValue);

      return /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        required: required,
        label: label,
        labelStyle: labelStyle,
        labelFor: name
      }, /*#__PURE__*/_react["default"].createElement(Select, (0, _extends2["default"])({
        required: required
      }, rest), SelectPlaceholder, _lodash["default"].map(options, function (item, k) {
        return /*#__PURE__*/_react["default"].createElement(SelectOptions, {
          key: k,
          item: item
        });
      })), error.length !== 0 && /*#__PURE__*/_react["default"].createElement(_InputError["default"], null, error));
    }
  }]);
  return SelectInput;
}(_react.Component);

var SelectOptions = function SelectOptions(_ref) {
  var _ref$item = _ref.item,
      value = _ref$item.value,
      label = _ref$item.label;
  return /*#__PURE__*/_react["default"].createElement("option", {
    value: value === 0 ? value : value || _lodash["default"].snakeCase(label)
  }, label);
};

SelectInput.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(["dark", "light", "darker", "muted", "achievement"]),
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].array.isRequired,
  value: _propTypes["default"].string,
  initialValue: _propTypes["default"].string,
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
SelectInput.defaultProps = {
  name: "select_dropdown",
  onChange: function onChange() {
    return false;
  },
  inputStyle: "achievement",
  labelStyle: "dark",
  initialValue: "---Choose One---",
  style: {},
  error: ""
};
var _default = SelectInput;
exports["default"] = _default;